module.exports = __webpack_public_path__ + "static/media/Bottom-Of-Foot(L) v1.bfbf2764.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Bottom-Of-Foot(L) v1.jpg
// module id = 410
// module chunks = 0